module.exports = __webpack_public_path__ + "img/ic_kaoshi_blue.9cca6bef.svg";